// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3XZ4P","product_name":"Info_product_name__1TcQY","sku":"Info_sku__SlZvc","info_bottom":"Info_info_bottom__SYyIU","price":"Info_price__1wIpf"};